import React from 'react'

function Aboutdept() {
  return (
    <>
    <div className=''>
        <div className='animate-pulse pt-10 grid place-items-center lg:place-items-center lg:pt-20 lg:pr-30 opacity-70'>
            {/* <div className='duration-500 scale-100 float-right text-[16px] lg:text-2xl sm:text-sm md:text-xl w-44 sm:w-40 md:w-48 lg:w-60 p-4 lg:p-8 font-semibold bg-gradred/100'>
                <h5 className='text-[white] text-center border-b-4  border-[#f59e0b] pb-2'>ABOUT<br></br>
                <span className='font-bold'>DEPARTMENT
                </span></h5>
            </div> */}
        </div>

        <div className=' w-full pl-10 lg:mr-8 lg:-mt-25 lg:pl-50 lg:pr-20'>
            <div className='lg:w-full scale-100  pl-8 py-10 lg:pl-12 lg:py-10 w-11/12 bg-black/40  border-2 border-blue-900 rounded-xl '>
            <h5 className='w-40 text-[white] text-left border-b-4  border-blue-900 pb-2'>ABOUT<br></br>
                    <span className='font-bold'>DEPARTMENT
                    </span></h5>
                    <br/>
                <p className='lg:w-full text-white pl-4 pr-8 lg:pr-12 lg:pl-8  text-justify text-xs sm:text-sm md:text-sm lg:text-[16px] backdrop-blur'>
                The Department of Computer Science and Engineering joined the fleet of Sri Sai Ram Engineering College during the academic year 1998-99. 
                The Department of Computer Science and Engineering, since its establishment, has been in constant pursuit of excellence. 
                Our endeavor has been to produce the best computing technocrats to serve the growing needs of the country in the field of computing. 
                Here we strive to produce world class professionals who can compete with the industry's best brains. 
                The Department is also having a Master of Engineering in Computer Science and Engineering from the academic year 2011-2012. 
                The Department is accredited with the National Board of Accreditation (NBA). 
                It is equipped with well qualified and experienced teaching staff and supporting staff, a computing lab with 380 workstations and 6 servers with all the required software and peripherals as per Anna University syllabus, 155Mbps (TATA) RF connectivity. 
                The Department has bagged 203 University ranks including University Gold Medals. 
                On an average 90% of our students get placement on campus in leading companies like Zoho, Accenture, TCS, CTS, Infosys, IBM, HCL, Wipro, Tech Mahindra, L&T Infotech etc. 
                The Department conducts National level technical symposium SAI COMPFEST SYNSARA every year for students and organizes ATAL Faculty Development Programs, Guest lectures, Seminars, Workshops, Webinars, Industrial visits at regular intervals. 
                The Department library provides useful resources to students with books on various titles, e-journals, National Journals, Magazines, Lab Manuals, Question banks and Project Reports. 
                The Department is an Institutional member of the Computer Society of India and also has a student chapter of CSI which regularly organizes various value added programs for the benefit of the students. 
                Computer Network Lab was modernized under the scheme of MODROB. The Department is recognized as a Research Centre under Anna University from November 2019.
                </p>
            </div>
        </div>
    </div>
    </>
  )
}

export default  Aboutdept